/** OpenLayers grid-system factory for FrenchLambert; the theatre data itself is ol-free in `FrenchLambert.ts`. */
import { createMBSGridSystem } from './shared.js';
import { ZONES } from './FrenchLambert.js';
function createFrenchLambert(zone, options) {
    const spec = ZONES[zone];
    return createMBSGridSystem(spec.crs, spec.proj4, spec.scheme, spec.clipPolygon, options);
}
export const createFrenchLambert1GridSystem = (options) => createFrenchLambert(1, options);
export const createFrenchLambert2GridSystem = (options) => createFrenchLambert(2, options);
export const createFrenchLambert3GridSystem = (options) => createFrenchLambert(3, options);
//# sourceMappingURL=FrenchLambert.grid.js.map